/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Previous_PeriodInputs */



/**
* | output |
* | --- |
* | "Previous Period" |
*
* @param {Usage_Previous_PeriodInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_previous_period = /** @type {((inputs?: Usage_Previous_PeriodInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Previous_PeriodInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Période précédente")
	if (locale === "de") return /** @type {LocalizedString} */ ("vorherige Periode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Periodo precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предыдущий период")
	if (locale === "es") return /** @type {LocalizedString} */ ("Periodo anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上期")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前期")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछली अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Período anterior")
	return /** @type {LocalizedString} */ ("Previous Period")
});